<template>
  <ul v-if="$vuetify.breakpoint.smAndUp">
    <v-row>
      <v-col md="12">
        <v-row>
          <v-col md="8">
            <template v-if="isLoggedIn">
              <li style="z-index: 999;">
                <!--Notification - Nothing made yet-->
                <Notification></Notification>
                <!--Profile Selection-->
                <ProfileSelection></ProfileSelection>
                <!--Language selector-->
                <LanguageSelector></LanguageSelector>
              </li>
            </template>

            <template v-else>
              <span><v-btn to="/login">{{$t('Login')}}</v-btn></span>
              <span><v-btn to="/register">{{$t('Sign up')}}</v-btn></span>
            </template>
          </v-col>
        </v-row>
      </v-col>
      <v-row>
      <v-col md="4"></v-col>
      <v-col md="6" class="justify-center">
        <v-text-field prepend-inner-icon="search"></v-text-field>
      </v-col>
      </v-row>
    </v-row>
  </ul>

  <ul v-else>
    <li>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in items" :key="index">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
          <template v-if="isLoggedIn">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{fullName}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <!-- <v-list-item to="/private">
              <v-list-item-content>
                <v-list-item-title>{{$t('Dashboard')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item to="/private/profilesettings">
              <v-list-item-content>
                <v-list-item-title>{{$t('Profile Settings')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list-item to="/logout">
              <v-list-item-content>
                <v-list-item-title>{{$t('Logout')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-else>
            <v-list-item to="/login">
              <v-list-item-content>
                <v-list-item-title>{{$t('Login')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/register">
              <v-list-item-content>
                <v-list-item-title>{{$t('Sign up')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </li>
  </ul>
</template>

<script>
import messages from "../modules/lang/main/export";
import { mapGetters, mapActions } from "vuex";
import "@/assets/flag-icon.css";
import Notification from "@/components/navbar/components/notification.vue";
import ProfileSelection from "@/components/navbar/components/profile_selection.vue";
import LanguageSelector from "@/components/navbar/components/language_selector.vue";
export default {
  components: {
    Notification,
    ProfileSelection,
    LanguageSelector
  },
  i18n: { messages },
  data() {
    return {
      languagePicked:"",
      iconsize: "2em",
      languages: [{ short: "nb", icon: "no" }, { short: "en", icon: "gb" }],
      selectedlanguage: localStorage.getItem("setlanguage") || "en"
    };
  },
  methods: {
    changelanguage(newlang) {
      this.$root.changeLocale(newlang);
      this.selectedlanguage = newlang;
    }
  },
  watch: {
    getLang(newLocale) {
      this.selectedlanguage = newLocale;
    }
  },
  computed: {
    ...mapGetters(["isLoggedIn", "fullName", "updateStatus", "getLang"])
  }
};
</script>

<style scoped>
ul {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  width: 100%;
  /* height: 50px; */
  margin: 0;
  padding: 0;
}
li {
  display: block;
  flex: 0 1 auto; /* Default */
  list-style-type: none;
  /* background: #aaa; */
  /* margin: 0 5px; */
  align-self: center;
}

li:last-child {
  margin-right: 0;
}
li a {
  text-decoration: none;
  color: inherit;
  /* margin: 20px; */
}
</style>


